var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83299 15.9947H16.1983C18.117 15.9947 19.6094 14.5023 19.6094 12.6902V3.30964C19.6094 1.49749 18.117 0.00512695 16.1983 0.00512695H3.83299C1.91424 0.00512695 0.421875 1.49749 0.421875 3.30964V12.7968C0.421875 14.5023 1.91424 15.9947 3.83299 15.9947ZM16.1983 14.1826H3.83299C2.98021 14.1826 2.23403 13.543 2.23403 12.6902V5.86797L7.1375 9.27908C8.84306 10.4517 11.0816 10.4517 12.6806 9.27908L17.584 5.86797V12.7968C17.7972 13.543 17.051 14.1826 16.1983 14.1826ZM3.83299 1.81728H16.1983C17.051 1.81728 17.7972 2.45686 17.7972 3.30964V3.73603L11.7212 7.89332C10.6552 8.6395 9.37604 8.6395 8.31007 7.89332L2.23403 3.62943V3.30964C2.23403 2.45686 2.98021 1.81728 3.83299 1.81728Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMail);
export default __webpack_public_path__ + "static/media/ContactMail.fca36a3c3fc9923c1a71867a14b47867.svg";
export { ForwardRef as ReactComponent };